<template id="">
    <div class="logo">
        <router-link :class="anchorClass" :to="anchorLink">
            <img v-if="inverseLogo" :src="inverseLogo" class="inverse" />
            <!-- <img :src="clientLogo" class="main" /> -->
            <img v-if="mainLogo" :src="mainLogo" class="main" />
        </router-link>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        anchorClass: {
            type: String,
            default: '',
        },
        anchorLink: {
            type: String,
            default: '/insights',
        },
        type: {
            type: String,
            default: '1',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            clientLogo: '',
            mainLogo: '',
            inverseLogo: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['displaySettings', 'isPrintMode']),
    }, // End of Component > mounted
    watch: {
        displaySettings(value) {
            if (value) {
                this.getDisplaySettingConf()
            }
        },
        isPrintMode(value) {
            this.getDisplaySettingConf()
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getDisplaySettingConf()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getDisplaySettingConf() {
            if (this.displaySettings) {
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--primary-color',
                        this.displaySettings.colors.primary
                    )
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--secondary-color',
                        this.displaySettings.colors.secondary
                    )
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--interface-medium-color',
                        this.displaySettings.colors.light
                    )
                document
                    .querySelector(':root')
                    .style.setProperty(
                        '--interface-dark-color',
                        this.displaySettings.colors.dark
                    )
            }
            // Use client logo when in print mode, otherwise use normal logos

            if (
                this.displaySettings &&
                this.displaySettings.clientLogo &&
                this.$route.path.includes('deep-register')
            ) {
                // Deep-link journey: show client logo
                this.mainLogo = `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.clientLogo}`
                this.inverseLogo = `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.clientLogo}`
            } else if (
                this.isPrintMode &&
                this.displaySettings &&
                this.displaySettings.clientLogo
            ) {
                // PDF export: show client logo
                this.mainLogo = `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.clientLogo}`
                this.inverseLogo = `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.clientLogo}`
            } else {
                // Default: show global Idenfo logos
                this.mainLogo = this.displaySettings
                    ? `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.logo.dark.fileName}`
                    : ''
                this.inverseLogo = this.displaySettings
                    ? `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.logo.light.fileName}`
                    : ''
            }
        },
    },
} // End of export default
</script>
